import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { contactToShortName } from '../../../shared/modules/contacts/functions/contact-to-short-name.function';
import { ProtoContactDto } from '../../contacts/dtos/proto-contact.dto';
import { ProtoDriverDto } from '../../drivers/dtos/proto-driver.dto';
import { AccountStatusEnum } from '../enums/account-status.enum';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * Account DTO for lists
 */
@CaslSubject(AppSubjectEnum.ACCOUNT)
export class AccountListDto extends BaseDto {
	code!: string;
	tenantOrgId?: string;
	email!: string;
	type!: AccountTypeEnum;
	status!: AccountStatusEnum;
	contact!: ProtoContactDto;
	driver?: ProtoDriverDto;

	mobileTitle = (): string | null => {
		const contactName = contactToShortName(this.contact);

		return `${this.code}${contactName ? ' - ' + contactName : ''}`;
	};

	mobileSubtitle = (): string | null => {
		const email = this.contact?.email;
		const phoneMobile = this.contact?.phoneMobile;

		return phoneMobile
			? `${phoneMobile}${email ? ' / ' + email : ''}`
			: email
				? `${email}`
				: '';
	};
}
